import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EditTripForm from './EditTripForm';
import { AlertCircle } from 'lucide-react';

const EditTripDialog = ({ open, onOpenChange, tripData, onUpdateTrip }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
 
  const canEditTrip = tripData ? (
    tripData.status !== 'COMPLETED' && 
    tripData.status !== 'ACTIVE' && 
    tripData.status !== 'AUTO_COMPLETE' && 
    tripData.status !== 'AUTO_COMPLETED'
  ) : true;

  const handleSubmit = async (tripData) => {
    setIsSubmitting(true);
    try {
      await onUpdateTrip(tripData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[96vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Trip</DialogTitle>
        </DialogHeader>
        
        {!canEditTrip && (
          <div className="rounded-md border border-destructive bg-destructive/10 p-4 mb-4">
            <div className="flex">
              <AlertCircle className="h-5 w-5 text-destructive mr-2 mt-0.5" />
              <div>
                <h3 className="font-medium text-destructive">Cannot Edit Trip</h3>
                <p className="text-sm text-destructive/90 mt-1">
                  This trip is {tripData?.status?.toLowerCase()} and cannot be edited.
                  Only trips with status SCHEDULED or PENDING can be edited.
                </p>
              </div>
            </div>
          </div>
        )}
        
        {canEditTrip ? (
          <EditTripForm 
            tripData={tripData} 
            onUpdateTrip={handleSubmit} 
            onCancel={() => onOpenChange(false)} 
            isSubmitting={isSubmitting}
          />
        ) : (
          <div className="flex justify-end mt-4">
            <button
              onClick={() => onOpenChange(false)}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Close
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditTripDialog;